import { merge } from 'lodash';
import Card from './Card';
import Lists from './Lists';
import Paper from './Paper';
import Input from './Input';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import IconButton from './IconButton';
import Autocomplete from './Autocomplete';
import Link from './Link';
import Table from './Table';
import Checkbox from './Checkbox';
import Radio from './Radio';
import Switch from './Switch';

// ----------------------------------------------------------------------

export default function ComponentsOverride(theme) {
  return merge(
    Card(theme),
    Lists(theme),
    Paper(theme),
    Input(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    IconButton(theme),
    Autocomplete(theme),
    Link(theme),
    Table(theme),
    Checkbox(theme),
    Radio(theme),
    Switch(theme)
  );
}
